/* eslint-disable react/prop-types */ // TODO: add props
import { SafeHTML } from 'edrolo/domains/app';
import { WistiaPlayer } from 'edrolo/domains/video';
import SectionHeading from '../SectionHeading';

const QuestionSolution = ({
  headingText,
  questionId,
  explanation,
  videoHash,
  videoThumbnailUrl,
}) => {
  if (!explanation && !videoHash) {
    return null;
  }

  return (
    <div>
      {headingText && <SectionHeading>Solution</SectionHeading>}
      {videoHash && (
        <WistiaPlayer
          videoHash={videoHash}
          thumbnailUrl={videoThumbnailUrl}
          origin="lesson-questions"
          appLabel="lesson-questions"
          model="question"
          objectId={questionId}
          speedControl
        />
      )}
      {explanation && <SafeHTML>{explanation}</SafeHTML>}
    </div>
  );
};

export default QuestionSolution;
